"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("@mdi/react"));
const react_2 = __importStar(require("react"));
const react_multi_carousel_1 = __importDefault(require("react-multi-carousel"));
require("react-multi-carousel/lib/styles.css");
const react_router_dom_1 = require("react-router-dom");
function CarouselComponent({ elements }) {
    const { id } = react_router_dom_1.useParams();
    const carouselRef = react_2.useRef(null);
    const responsive = {
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 2,
            partialVisibilityGutter: 30,
        },
    };
    return (react_2.default.createElement("div", { className: "is-hidden-tablet pt-6 pb-5 has-background-white" },
        react_2.default.createElement(react_multi_carousel_1.default, { arrows: false, draggable: true, keyBoardControl: true, minimumTouchDrag: 60, partialVisible: true, responsive: responsive, slidesToSlide: 1, swipeable: true, focusOnSelect: true, ref: carouselRef, afterChange: (previousSlide, state) => {
                var _a;
                const elements = state.totalItems;
                if (state.currentSlide + 1 === elements)
                    (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.goToSlide(elements - 2);
            } }, elements.map((el) => (react_2.default.createElement(react_router_dom_1.Link, { key: el.path + el.name, to: el.path, className: `is-block has-height-150 has-border2 border-color-normal border-radius-small mx-2 p-3 is-relative ${id === el.path.split("/").pop() ? "carousel-is-active" : ""}` },
            react_2.default.createElement("h2", { className: "has-text-black100" }, el.name),
            react_2.default.createElement("figure", { className: "carousel-icon" },
                react_2.default.createElement(react_1.default, { path: el.icon, size: 1 }))))))));
}
exports.default = CarouselComponent;
//# sourceMappingURL=Carousel.js.map